import {
  RecaptchaBrandingText as BaseRecaptchaBrandingText,
} from '@/components/recaptcha-branding-text';

import { RECAPTCHA_BRANDING_TEXT_EXTRA_MESSAGE } from './constants';
import type { Component } from './types';

export const RecaptchaBrandingText: Component = () => (
  <BaseRecaptchaBrandingText
    extraMessage={RECAPTCHA_BRANDING_TEXT_EXTRA_MESSAGE} />
);
